import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Chat from "@/pages/Chat";
import AgentProfile from "@/pages/AgentProfile";
import Settings from "@/pages/Settings";
import Briefings from "@/pages/Briefings";
import Pilotes from "@/pages/Pilotes";
import Prospects from "@/pages/Prospects";
import Agents from "@/pages/Agents";
import Playbook from "@/pages/Playbook";
import Documents from "@/pages/Documents";
import Emails from "@/pages/Emails";
import Mission from "@/pages/Mission";
import Social from "@/pages/Social";
import Prospection from "@/pages/Prospection";
import Relances from "@/pages/Relances";
import Subscriptions from "@/pages/Subscriptions";
import BusinessCenter from "@/pages/BusinessCenter";
import AvatarPreview from "@/pages/AvatarPreview";

function Protected({ children }) {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster theme="dark" position="top-right" />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/preview-avatars" element={<AvatarPreview />} />
          <Route path="/login" element={<Login />} />
          <Route path="/app" element={<Protected><Dashboard /></Protected>} />
          <Route path="/app/pilotes" element={<Protected><Pilotes /></Protected>} />
          <Route path="/app/prospects" element={<Protected><Prospects /></Protected>} />
          <Route path="/app/prospection" element={<Protected><Prospection /></Protected>} />
          <Route path="/app/relances" element={<Protected><Relances /></Protected>} />
          <Route path="/app/abonnements" element={<Protected><Subscriptions /></Protected>} />
          <Route path="/app/business" element={<Protected><BusinessCenter /></Protected>} />
          <Route path="/app/agents" element={<Protected><Agents /></Protected>} />
          <Route path="/app/playbook" element={<Protected><Playbook /></Protected>} />
          <Route path="/app/documents" element={<Protected><Documents /></Protected>} />
          <Route path="/app/emails" element={<Protected><Emails /></Protected>} />
          <Route path="/app/mission" element={<Protected><Mission /></Protected>} />
          <Route path="/app/social" element={<Protected><Social /></Protected>} />
          <Route path="/app/agents/:code" element={<Protected><AgentProfile /></Protected>} />
          <Route path="/app/chat" element={<Protected><Chat /></Protected>} />
          <Route path="/app/chat/:agentCode" element={<Protected><Chat /></Protected>} />
          <Route path="/app/chat/:agentCode/:conversationId" element={<Protected><Chat /></Protected>} />
          <Route path="/app/briefings" element={<Protected><Briefings /></Protected>} />
          <Route path="/app/settings" element={<Protected><Settings /></Protected>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
